"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/echartsNew/index"));
var _priceSetting = require("@/api/priceSetting.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'monitoringStatistics',
  components: {
    echartsNew: _index.default
  },
  data: function data() {
    return {
      radio: 'week',
      style: {
        height: '500px'
      },
      myChart: null,
      optionData: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['上涨', '下降']
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value',
          name: '调价商品数（件）',
          minInterval: 1
        },
        series: [{
          name: '上涨',
          type: 'line',
          color: 'green',
          smooth: true,
          data: [320, 132, 101, 134, 90, 230, 210]
        }, {
          name: '下降',
          type: 'line',
          color: 'red',
          smooth: true,
          data: [120, 182, 191, 234, 290, 330, 310]
        }]
      },
      dashboardStatisticsdata: {
        priceDownChangeRate: 0,
        priceDownCount: 0,
        priceUpChangeRate: 0,
        priceUpCount: 0,
        productCountChangeRate: 0,
        totalProductCount: 0,
        warnChangeRate: 0,
        warnCount: 0,
        yesterdayPriceDownCount: 0,
        yesterdayPriceUpCount: 0,
        yesterdayProductCount: 0,
        yesterdayWarnCount: 0
      },
      keyNum: 0 // 强制更新echarts
    };
  },
  mounted: function mounted() {},
  methods: {
    toggleTab: function toggleTab() {
      this.$emit('toggleTab', {
        name: 'second'
      });
    },
    getDashboardStatistics: function getDashboardStatistics() {
      var _this = this;
      (0, _priceSetting.dashboardStatistics)().then(function (res) {
        _this.dashboardStatisticsdata = res;
      });
    },
    priceTrend: function priceTrend() {
      var _this2 = this;
      (0, _priceSetting.priceTrend)({
        timeType: this.radio
      }).then(function (res) {
        console.log(res);
        _this2.optionData.xAxis.data = res.dateList;
        _this2.optionData.series[0].data = res.priceUpList;
        _this2.optionData.series[1].data = res.priceDownList;
        _this2.keyNum++;
      });
    }
  }
};